<div
	#overlay
	class="quick-actions-overlay"
	[class.visible]="isVisible()"
	(click)="onOverlayClick($event)"
>
	<div #container class="quick-actions-container" tabindex="-1">
		<div class="quick-actions-header">
			<lowgile-search-input
				(queryChange)="onSearchQueryChange($event)"
			></lowgile-search-input>
		</div>
		<div class="quick-actions-content">
			@if (prefixHelper()) {
				<div class="prefix-helper">{{ prefixHelper() }}</div>
			}
			<lowgile-results-list
				[actions]="filteredActions()"
				[activeIndex]="activeIndex()"
				[query]="currentQuery()?.query ?? ''"
				(actionSelect)="onActionSelect($event)"
			></lowgile-results-list>
		</div>
	</div>
</div>
